import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    meta: {layout: 'empty'},
    component: () => import('../views/Login.vue')
  },
  {
    path: '/',
    name: 'Home',
    meta: {layout: 'main'},
    component: () => import('../views/Home.vue')
  },
  {
    path: '/4',
    name: '4',
    meta: {layout: 'main'},
    component: () => import('../components/4/4_main.vue')
  },
  {
    path: '/5',
    name: '5',
    meta: {layout: 'main'},
    component: () => import('../components/5/5_main.vue')
  },
  {
    path: '/11',
    name: '11',
    meta: {layout: 'main'},
    component: () => import('../components/11/11_main.vue')
  },
  {
    path: '/15',
    name: '15',
    meta: {layout: 'main'},
    component: () => import('../components/15/15_main.vue')
  },
  {
    path: '/22',
    name: '22',
    meta: {layout: 'main'},
    component: () => import('../components/22/22_main.vue')
  },
  {
    path: '/23',
    name: '23',
    meta: {layout: 'main'},
    component: () => import('../components/23/23_main.vue')
  },
  {
    path: '/24',
    name: '24',
    meta: {layout: 'main'},
    component: () => import('../components/24/24_main.vue')
  },
  {
    path: '/28',
    name: '28',
    meta: {layout: 'main'},
    component: () => import('../components/28/28_main.vue')
  },
  {
    path: '/27',
    name: '27',
    meta: {layout: 'main'},
    component: () => import('../components/27/27_main.vue')
  },
  {
    path: '/29',
    name: '29',
    meta: {layout: 'main'},
    component: () => import('../components/29/29_main.vue')
  },
  {
    path: '/30',
    name: '30',
    meta: {layout: 'main'},
    component: () => import('../components/30/30_main.vue')
  },
  {
    path: '/31',
    name: '31',
    meta: {layout: 'main'},
    component: () => import('../components/31/31_main.vue')
  },
  {
    path: '/33',
    name: '33',
    meta: {layout: 'main'},
    component: () => import('../components/33/33_main.vue')
  },
  {
    path: '/34',
    name: '34',
    meta: {layout: 'main'},
    component: () => import('../components/34/34_main.vue')
  },
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})



export default router
